import { render } from "./PageAccessInfoCard.vue?vue&type=template&id=b9250784&scoped=true"
import script from "./PageAccessInfoCard.vue?vue&type=script&lang=js"
export * from "./PageAccessInfoCard.vue?vue&type=script&lang=js"

import "./PageAccessInfoCard.vue?vue&type=style&index=0&id=b9250784&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.8.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9250784"]])

export default __exports__